<template>
  <div class="headerbar flex flex-t-center flex-space ">
    <div>
      <img :src="logo" alt="logo">
    </div>
    <div class="right-menu flex flex-j-center">
      <!-- <el-button type="text" @click="setNightCss">暗黑模式</el-button> -->
      <!-- <el-color-picker v-model="color" size="small" @change="colorChange" /> -->
      <div v-if="userInfo.accountType === 0 && !adminPermission && userInfo.enterpriseId" class="route-shortcut">
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title />
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="首页/企业管理后台" transform="translate(-1118.000000, -22.000000)">
              <g id="编组-9备份" transform="translate(1102.000000, 14.000000)">
                <g id="编组-14" transform="translate(16.000000, 8.000000)">
                  <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="16" height="16" />
                  <path id="形状结合" d="M15.0689891,13.205377 L15.0689891,13.8001169 L13.9622679,15.2 L12.707563,15.2 L12.707563,15.089889 L13.4131153,14.195675 L10.8595209,14.195675 L10.8595209,13.205377 L15.0689891,13.205377 Z M9.6,14 L9.6,15.2 L3.48108108,15.2 L3.48108108,14 L9.6,14 Z M15.6,0.8 L15.6,9.599 L14.367,9.599 L14.3675676,2 L1.63243243,2 L1.63243243,11.2 L9.6,11.199 L9.6,12.399 L0.4,12.4 L0.4,0.8 L15.6,0.8 Z M13.2202457,10.4 L13.2202457,10.5094097 L12.5146934,11.4036236 L15.0689891,11.4036236 L15.0689891,12.394623 L10.8595209,12.394623 L10.8595209,11.7991818 L11.9662422,10.4 L13.2202457,10.4 Z M5.53513514,6.05759999 L5.53513514,8.85759999 L4.30270271,8.85759999 L4.30270271,6.05759999 L5.53513514,6.05759999 Z M8.61621622,4.4576 L8.61621622,8.85759999 L7.38378378,8.85759999 L7.38378378,4.4576 L8.61621622,4.4576 Z M11.6972973,5.6576 L11.6972973,8.85759999 L10.4648649,8.85759999 L10.4648649,5.6576 L11.6972973,5.6576 Z" fill="#4E5969" fill-rule="nonzero" />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <el-button class="company-manage" type="text" @click="goManage(1)">企业管理后台</el-button>
      </div>
      <div v-else-if="userInfo.accountType === 0 && adminPermission && userInfo.enterpriseId" class="route-shortcut">
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title />
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="首页/企业管理后台" transform="translate(-1118.000000, -22.000000)">
              <g id="编组-9备份" transform="translate(1102.000000, 14.000000)">
                <g id="编组-14" transform="translate(16.000000, 8.000000)">
                  <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="16" height="16" />
                  <path id="形状结合" d="M15.0689891,13.205377 L15.0689891,13.8001169 L13.9622679,15.2 L12.707563,15.2 L12.707563,15.089889 L13.4131153,14.195675 L10.8595209,14.195675 L10.8595209,13.205377 L15.0689891,13.205377 Z M9.6,14 L9.6,15.2 L3.48108108,15.2 L3.48108108,14 L9.6,14 Z M15.6,0.8 L15.6,9.599 L14.367,9.599 L14.3675676,2 L1.63243243,2 L1.63243243,11.2 L9.6,11.199 L9.6,12.399 L0.4,12.4 L0.4,0.8 L15.6,0.8 Z M13.2202457,10.4 L13.2202457,10.5094097 L12.5146934,11.4036236 L15.0689891,11.4036236 L15.0689891,12.394623 L10.8595209,12.394623 L10.8595209,11.7991818 L11.9662422,10.4 L13.2202457,10.4 Z M5.53513514,6.05759999 L5.53513514,8.85759999 L4.30270271,8.85759999 L4.30270271,6.05759999 L5.53513514,6.05759999 Z M8.61621622,4.4576 L8.61621622,8.85759999 L7.38378378,8.85759999 L7.38378378,4.4576 L8.61621622,4.4576 Z M11.6972973,5.6576 L11.6972973,8.85759999 L10.4648649,8.85759999 L10.4648649,5.6576 L11.6972973,5.6576 Z" fill="#4E5969" fill-rule="nonzero" />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <el-button class="company-manage" type="text" @click="goManage(2)">门户平台</el-button>
      </div>
      <div class="header-notice-content">
        <header-notify />
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper flex flex-t-center">
          <img :src="userInfo.avatar || defaultAvatar" class="user-avatar">
          <span class="name">{{ userInfo.name }}</span>
          <i class="el-icon-arrow-down" />
        </div>
        <el-dropdown-menu slot="dropdown" class="header-dropdown">
          <el-dropdown-item v-if="userInfo.accountName" disabled>
            <span style="display:block;">{{ userInfo.accountName }}</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="userInfo.accountName" @click.native="changeCompany">
            <span style="display:block;">切换企业</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <company-choose :visible.sync="visible" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { setLogoutFlag, getUserTokenKey, removeToken } from '@/utils/auth'
import { isChangeTheme } from '@/utils/colorPicker.js'
import HeaderNotify from '@/layout/components/HeaderNotify.vue'
import CompanyChoose from '@/components/CompanyChoose/index.vue'
export default {
  components: {
    HeaderNotify,
    CompanyChoose
  },
  data() {
    return {
      color: '',
      logo: require('@/assets/bpmLogo.png'),
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      count: 0, // 通知栏数量
      visible: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    ...mapState('user', ['userInfo']),
    adminPermission() {
      const match = this.$route.matched
      return match.find((item) => item.path === '/companyManage')
    }
  },
  methods: {
    setNightCss() {
      !document.querySelector('body').className ? document.querySelector('body').className = 'dark' : document.querySelector('body').className = ''
    },
    colorChange() {
      isChangeTheme(this.color)
    },
    async logout() {
      window.isSelfLoginOut = true // 判断是否手动退出
      await this.$store.dispatch('user/logout', this.$store.state.user.ssoToken)
      setLogoutFlag()
      localStorage.removeItem('accountName')
      let ssoToken = getUserTokenKey()
      const isSsoToken = localStorage.getItem('is-sso-login')
      if (this.$store.state.user.ssoToken) {
        ssoToken = this.$store.state.user.ssoToken
      }
      if (ssoToken && isSsoToken) {
        localStorage.removeItem('is-sso-login')
        this.$store.commit('user/SET_SSOTOKEN', '')
        removeToken()
        const hostName = window.location.hostname.split('.')[1]
        if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SECRET === 'prod') {
          window.location.href = `https://in-sso.${hostName}.com/logout?token=${ssoToken}&backUrl=https://bpm.${hostName}.com/`
        } else {
          window.location.href = `https://prein-sso.${hostName}.com/logout?token=${ssoToken}&backUrl=https://prebpm.${hostName}.com/`
        }
      } else {
        removeToken()
        const isConsole = sessionStorage.getItem('isConsole')
        const backUrl = sessionStorage.getItem('backUrl')
        if (isConsole) {
          if (backUrl) {
            window.location.href = isConsole
            return
          } else {
            window.location.href = process.env.VUE_APP_CONSOLEURL
            return
          }
        }
        this.$router.push('/login')
      }
    },
    // 切换企业
    changeCompany() {
      this.visible = true
    },
    // 跳转到企业或者门户
    goManage(type) {
      console.log('this.$route', this.$route)
      if (type === 1) {
        this.$router.push('/companyManage/appManage')
      } else if (type === 2) {
        this.$router.push('/home/index')
      }
    }
  }
}
</script>

<style lang="scss" scope>
  .header-dropdown {
    padding: 8px;
    .el-dropdown-menu__item {
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
      color: #333333;
      font-size: 14px;
      &:hover {
        font-weight: 600;
        color: #2F4BDD;
      }
    }
  }
  .headerbar{
    height: 60px;
    background: #fff;
    box-shadow: inset 0px -1px 0px 0px #E9EBF2;
    padding: 0 20px;
    .right-menu {
      float: right;
      // height: 100%;
      // line-height: 50px;

      &:focus {
        outline: none;
      }
      .route-shortcut {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 32px;
        padding: 0px 16px;
        background: #f2f3f5;
        border-radius: 2px;
        margin-top: 12px;
        margin-right: 8px;
        .company-manage {
          margin-left: 6px;
          color: #9ea6b0;
        }
        svg {
          path {
            fill: #808894;
          }
        }
        &:hover {
          .company-manage {
            color: #808894;
          }
          svg {
            path {
              fill: #79828e;
            }
          }
        }
      }
      .header-notice-content {
        display: flex;
        display: flex;
        align-items: center;
        margin-right: 20px;
        padding: 5px 10px 0px 8px;
        cursor: pointer;
        &:hover {
            background: rgba(0, 0, 0, .025)
          }
        .notice {
          width: 32px;
          height: 32px;
          .el-badge__content {
            height: 20px;
            &.is-fixed {
              top: 5px;
              right: 17px;
            }
          }
        }
        svg {
          font-size: 32px;
        }
      }
      .right-menu-item {
        display: inline-block;
        // padding: 0 8px;
        // height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
        /deep/.el-dropdown-menu  {
          padding: 8px;
        }
      }

      .avatar-container {
        // margin-right: 30px;

        .avatar-wrapper {
          padding: 8px 10px;
          border-radius: 4px;
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: block;
          }
          .name {
            padding-left: 8px;
            font-size: 14px;
          }
          .el-icon-arrow-down {
            cursor: pointer;
            // position: absolute;
            // right: -20px;
            // top: 16px;
            margin-left: 10px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
